import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { Box } from '@chakra-ui/react';

/**
 * An active indicator with a sliding animation.
 * It needs to be wrapped in a container with `position: relative`.
 *
 * @component
 *
 * @param {boolean} props.isActive - If true, the indicator is active.
 *
 * @returns {React.ReactNode} The rendered active indicator.
 */

function ActiveIndicator({ isActive, bg }) {
  return (
    <Box
      as={motion.hr}
      pos="absolute"
      bottom="0"
      left="50%"
      transform="translateX(-50%)"
      h="4px"
      bg={bg ?? 'brand.ink'}
      border="none"
      zIndex="1"
      margin="0"
      initial={{ width: 0, opacity: 0 }}
      animate={{
        width: isActive ? '100%' : 0,
        opacity: isActive ? 1 : 0,
      }}
      transition={{
        duration: 0.3,
        ease: 'easeInOut',
      }}
    />
  );
}

ActiveIndicator.defaultProps = {
  bg: undefined,
};

ActiveIndicator.propTypes = {
  isActive: PropTypes.bool.isRequired,
  bg: PropTypes.string,
};

export default ActiveIndicator;
